import { ISchedulerStudentPlan } from '../../interfaces/scheduler_student_plan';
import { SchedulerStudentPlanQuery } from '../../queries/scheduler_student_plan_query';
import { SearchAndCourseFeatureFacade } from '../../facades/search_and_courses_feature_facade';
import { SchedulerActiveTermQuery } from '../../../scheduler_active_term/queries/scheduler_active_term_query/scheduler_active_term_query';
import * as _4 from 'lodash4';
import { CourseSearchViewTemplate } from './course_search_view_template';
import { ScreenDeviceQuery } from 'screen-query';
import { NetworkUrlConfigurationProvider } from 'utility-ng-configuration';
import { AccountModel } from 'data-ng-authentication';
import { CourseSearchAuthorizationQuery } from '../../queries/course_search_authorization_query';

interface ICourseSearchHILConfig {
  term: {
    name: SchedulerActiveTermQuery['result']['name'];
    id: SchedulerActiveTermQuery['result']['id'];
  };
  planId: ISchedulerStudentPlan['id'];
}

const courseSearchPrefab = (
  courseSearchConfig: ICourseSearchHILConfig,
  networkURLConfig: NetworkUrlConfigurationProvider,
  accountModel: AccountModel,
  ngCourseSearchAuthorizationQuery: CourseSearchAuthorizationQuery
) => {
  if (typeof courseSearchConfig.term.id === 'undefined') {
    return {};
  }

  const prependUrl = _4.get(networkURLConfig.read(), 'prependUrl', '');

  const filterFieldsUrl = prependUrl + '/api/v1/cat/course_search/fields/?application=scheduler';
  const filterSettingsUrl = prependUrl + `/api/v1/cat/course_search/?term=${courseSearchConfig.term.id}`;
  const addCourseModifier = {
    $is: 'series',
    model: {
      term: courseSearchConfig.term.id,
      course: '[value]{ /id }',
      met_aside_from_term: false,
      kind: 'Planned Course'
    }
  };

  const authorization = ngCourseSearchAuthorizationQuery.result.authorization;

  CourseSearchViewTemplate.runtime.tasks.entity_filters.type.fields.settings.uri = filterFieldsUrl;
  CourseSearchViewTemplate.runtime.tasks.entity_filters.type.fields.settings.options.authorization = authorization;

  CourseSearchViewTemplate.runtime.tasks.filter_api.settings.uri = filterSettingsUrl;
  CourseSearchViewTemplate.runtime.tasks.filter_api.settings.options.authorization = authorization;

  CourseSearchViewTemplate.runtime.tasks.add_course_to_term.settings.options.authorization = authorization;
  CourseSearchViewTemplate.runtime.tasks.add_course_to_term.settings.uri =
    prependUrl + `/api/v1/ap3/studentplans/${courseSearchConfig.planId}/studentplanitems-infer-term/`;
  CourseSearchViewTemplate.runtime.tasks.add_course_to_term.before_modifiers = [];
  CourseSearchViewTemplate.runtime.tasks.add_course_to_term.before_modifiers.push(addCourseModifier);
  return _4.cloneDeep(CourseSearchViewTemplate);
};

class SearchAndAddCourses {
  private hideBackToPlannedCoursesLink: boolean = false;
  constructor(
    private $element: ng.IAugmentedJQuery,
    private ngSchedulerActiveTermQuery: SchedulerActiveTermQuery,
    private ngSchedulerStudentPlanQuery: SchedulerStudentPlanQuery,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private ngScreenDeviceQuery: ScreenDeviceQuery,
    private accountModel: AccountModel,
    private NetworkUrlConfiguration: NetworkUrlConfigurationProvider,
    private ngCourseSearchAuthorizationQuery: CourseSearchAuthorizationQuery
  ) {}

  initializeCourseSearchView() {
    if (!this.ngSearchAndCourseFeatureFacade.isFeatureEnabled) {
      return;
    }
    const aiView = this.$element[0].querySelector('hil-connector-by-input');
    const term = _4.get(this.ngSchedulerActiveTermQuery, 'result', undefined);
    const planId = _4.get(this.ngSchedulerStudentPlanQuery, 'result.id', undefined);
    if (aiView && term && planId) {
      aiView['input'] = courseSearchPrefab(
        {
          term,
          planId
        },
        this.NetworkUrlConfiguration,
        this.accountModel,
        this.ngCourseSearchAuthorizationQuery
      );
    }
  }

  $onInit() {
    this.initializeCourseSearchView();
  }
}

angular.module('capability-ng-scheduler').component('searchAndAddCourses', {
  templateUrl:
    'capability-ng-scheduler/src/search_and_add_courses/components/search_and_add_courses/search_and_add_courses.html',
  controller: SearchAndAddCourses
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/search_and_add_courses/components/search_and_add_courses/search_and_add_courses.ts